/// <reference types="./publishedGetEntity.d.ts" />
import { authVerifyAuthorizationKey } from '../Auth.js';
import { decodePublishedEntity } from '../EntityCodec.js';
import { validateEntityReference } from '../utils/ValidationUtils.js';
export async function publishedGetEntity(schema, authorizationAdapter, databaseAdapter, context, reference) {
    const validationResult = validateEntityReference(reference);
    if (validationResult.isError())
        return validationResult;
    const result = await databaseAdapter.publishedEntityGetOne(context, reference);
    if (result.isError())
        return result;
    const { authKey, resolvedAuthKey } = result.value;
    const authResult = await authVerifyAuthorizationKey(authorizationAdapter, context, {
        authKey,
        resolvedAuthKey,
    });
    if (authResult.isError())
        return authResult;
    return decodePublishedEntity(schema, result.value);
}
//# sourceMappingURL=publishedGetEntity.js.map